<template>
    <div>
        <a :href="this.row.path" :target="this.row.target">{{value}}</a>
    </div>
</template>
<script>
export default {
  props: ["value", "row", "urlPropertyName"]
}
</script>
